import { render, staticRenderFns } from "./MdrlEditCust.vue?vue&type=template&id=2b609855&"
import script from "./MdrlEditCust.vue?vue&type=script&lang=js&"
export * from "./MdrlEditCust.vue?vue&type=script&lang=js&"
import style0 from "./MdrlEditCust.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports